import React, { PropsWithChildren } from 'react';

interface IContext {
  incrementReviews: (toolId: string) => void;
  getCurrentReviewsCount: (toolId: string) => {
    currentSessionCount: number;
    allTimeCount: number;
  };
}

const TrainerReviewsContext = React.createContext<
  IContext | Record<string, never>
>({});

const useTrainerReviews = () => {
  const context = React.useContext(TrainerReviewsContext);
  if (context === undefined) {
    throw new Error('useTrainerReviews must be used within the Trainers');
  }
  return context;
};

const TrainerReviewsContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const getCurrentReviewsCount = (toolId: string) => {
    if (typeof window === 'undefined') {
      return { currentSessionCount: 0, allTimeCount: 0 };
    }

    if (!sessionStorage.getItem(toolId)) {
      sessionStorage.setItem(toolId, '0');
    }

    if (!localStorage.getItem(toolId)) {
      localStorage.setItem(toolId, '0');
    }

    const currentSessionCount = Number(sessionStorage.getItem(toolId));
    const allTimeCount = Number(localStorage.getItem(toolId));

    return { currentSessionCount, allTimeCount };
  };

  const incrementReviews = (toolId: string) => {
    const { currentSessionCount, allTimeCount } =
      getCurrentReviewsCount(toolId);

    sessionStorage.setItem(toolId, String(currentSessionCount + 1));
    localStorage.setItem(toolId, String(allTimeCount + 1));
  };

  return (
    <TrainerReviewsContext.Provider
      value={{
        incrementReviews,
        getCurrentReviewsCount,
      }}>
      {children}
    </TrainerReviewsContext.Provider>
  );
};

export { useTrainerReviews, TrainerReviewsContextProvider };
